import moment from "moment";

/**
 * YYYY. MM. DD にフォーマット
 * @param date 日付
 * @returns
 */
export const formatDate = (date: moment.MomentInput): string => {
  return moment(date, 'YYYY/MM/DD HH:mm:ss').format("YYYY. MM. DD");
};

export type Ordering = -1 | 0 | 1;

export const compareByDate = (a: moment.MomentInput, b: moment.MomentInput): Ordering => {
  const ordering = moment(a, 'YYYY/MM/DD HH:mm:ss').diff(moment(b, 'YYYY/MM/DD HH:mm:ss'));
  if (ordering < 0) {
    return -1;
  }
  if (ordering > 0) {
    return 1;
  }
  return 0;
}

/**
 * 配列を日付降順にソートする
 * @param arr
 * @param by
 * @returns
 */
export const sortedByDateDesc = <T>(
  arr: T[],
  by: (item: T) => moment.MomentInput
): T[] => {
  return [...arr].sort((a, b) => -compareByDate(by(a), by(b)));
};

/**
 * 配列を日付昇順にソートする
 * @param arr
 * @param by
 * @returns
 */
export const sortedByDateAsc = <T>(
  arr: T[],
  by: (item: T) => moment.MomentInput
): T[] => {
  return [...arr].sort((a, b) => compareByDate(by(a), by(b)));
};

/**
 * 現在から指定の日にちまでの日数差分を取得
 * @param {Date} date
 */
export const getDaysCountToEndDate = (date: Date): number => {
  // NOTE: 時間を 00:00:00 にして、日付のみの差分を取れるようにする
  const startDate = moment().hour(0).minutes(0).second(0).millisecond(0);
  const endDate = moment(date).hour(0).minutes(0).second(0).millisecond(0);
  return endDate.diff(startDate, 'days');
}
